import React from 'react';
import { usePUR5010_R01Store } from '../Store_PUR5010_R01';

interface SubtotalControlProps {
    className?: string;
}

export const SubtotalControl: React.FC<SubtotalControlProps> = ({ className = '' }) => {
    const {
        PUR5010_R01showSubtotals: showSubtotals,
        setPUR5010_R01ShowSubtotals: setShowSubtotals,
    } = usePUR5010_R01Store();
    const checkboxId = 'PUR5010_R01_showSubtotals';

    return (
        <>
            <style>{`
                .ag-row.subtotal-row {
                    background-color: #f0f8ff !important;
                    color: #2c5aa0 !important;
                    font-weight: bold !important;
                }
                .ag-row.subtotal-row:hover {
                    background-color: #f0f8ff !important;
                }
            `}</style>
            <div className={`flex items-center gap-2 px-4 py-1 ${className}`}>
                <label
                    htmlFor={checkboxId}
                    className="text-s cursor-pointer select-none"
                >
                    품목 소계
                </label>
                <input
                    id={checkboxId}
                    type="checkbox"
                    checked={showSubtotals}
                    onChange={(event) => setShowSubtotals(event.target.checked)}
                    className="h-4 w-4 cursor-pointer accent-blue-600"
                />
            </div>
        </>
    );
};
